var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-badge',{attrs:{"variant":_vm.badgeVariant}},[_vm._v(_vm._s(_vm.badgeLabel))])
}
var staticRenderFns = []

export { render, staticRenderFns }